import { render, staticRenderFns } from "./CancelStep2.vue?vue&type=template&id=85d177fc&scoped=true&"
import script from "./CancelStep2.vue?vue&type=script&lang=js&"
export * from "./CancelStep2.vue?vue&type=script&lang=js&"
import style0 from "./CancelStep2.vue?vue&type=style&index=0&id=85d177fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d177fc",
  null
  
)

export default component.exports